import { Box, Button, Checkbox, Typography } from '@mui/material';

import { useEffect, useRef, useState } from 'react';

import { Icon } from '@iconify/react';
import ReactLoading from 'react-loading';
import { generateClient } from 'aws-amplify/api';

import { SFNClient, StartExecutionCommand } from '@aws-sdk/client-sfn';

import { uploadData } from 'aws-amplify/storage';
import { useNavigate } from 'react-router-dom';

const EmptyStateText = ({ text }: { text: string }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: '1110px',

        justifyContent: 'flex-end',
        boxSizing: 'border-box',
      }}
    >
      <img
        alt="coinsEmptyState"
        src="/assets/background/coinsEmptyState.svg"
        style={{
          position: 'absolute',
          top: 50,
          left: 0,
          width: '760px',
          height: '941px',

          zIndex: 1,
        }}
      />
      <Typography
        sx={{ mt: '100px' }}
        zIndex={2}
        fontSize="48px"
        fontWeight="700"
        fontFamily={'AlmoniDL'}
        color="#343434"
      >
        {text}
      </Typography>
    </Box>
  );
};

export default EmptyStateText;
